export enum LectureVariants {
  Full = 'variant-full',
  Video = 'variant-video',
  Poster = 'variant-poster',
  Empty = 'variant-empty',
}
